import type { PlayerSeason } from "./players";

const sourceUrl = "https://statbunker.com/competitions/SeasonAppearances?comp_id=723";

type SourcedSeed = Omit<PlayerSeason, "era" | "season" | "source"> & {
  starts: number;
  statbunkerSubRaw: number;
};

const rows: SourcedSeed[] = [
  {
    id: "src22-provedel-lazio",
    name: "Ivan Provedel",
    club: "Lazio",
    roles: ["POR"],
    positionTags: ["portiere"],
    country: "Italia",
    score: 91,
    appearances: 38,
    starts: 37,
    statbunkerSubRaw: 1,
    goals: 0,
    tag: "Fonte 22/23",
    note: "Portiere Lazio con 38 presenze nella tabella StatBunker.",
  },
  {
    id: "src22-meret-napoli",
    name: "Alex Meret",
    club: "Napoli",
    roles: ["POR"],
    positionTags: ["portiere"],
    country: "Italia",
    score: 90,
    appearances: 34,
    starts: 34,
    statbunkerSubRaw: 0,
    goals: 0,
    tag: "Fonte 22/23",
    note: "Base del Napoli campione 2022-23 nella modalita fonte.",
  },
  {
    id: "src22-di-lorenzo-napoli",
    name: "Giovanni Di Lorenzo",
    club: "Napoli",
    roles: ["DIF"],
    positionTags: ["terzino", "quinto"],
    country: "Italia",
    score: 92,
    appearances: 37,
    starts: 36,
    statbunkerSubRaw: 2,
    goals: 2,
    tag: "Fonte 22/23",
    note: "Terzino da volume altissimo nel Napoli scudetto.",
  },
  {
    id: "src22-kim-napoli",
    name: "Min-Jae Kim",
    club: "Napoli",
    roles: ["DIF"],
    positionTags: ["centrale", "braccetto"],
    country: "Corea del Sud",
    score: 92,
    appearances: 35,
    starts: 35,
    statbunkerSubRaw: 2,
    goals: 2,
    tag: "Fonte 22/23",
    note: "Difensore centrale del Napoli 2022-23.",
  },
  {
    id: "src22-theo-milan",
    name: "Theo Hernandez",
    club: "Milan",
    roles: ["DIF"],
    positionTags: ["terzino", "quinto"],
    country: "Francia",
    score: 91,
    appearances: 32,
    starts: 32,
    statbunkerSubRaw: 2,
    goals: 4,
    tag: "Fonte 22/23",
    note: "Terzino offensivo con gol e molte partenze da titolare.",
  },
  {
    id: "src22-dimarco-inter",
    name: "Federico Dimarco",
    club: "Inter",
    roles: ["DIF"],
    positionTags: ["terzino", "quinto"],
    country: "Italia",
    score: 90,
    appearances: 33,
    starts: 26,
    statbunkerSubRaw: 8,
    goals: 4,
    tag: "Fonte 22/23",
    note: "Esterno sinistro Inter con impatto da gol.",
  },
  {
    id: "src22-danilo-juventus",
    name: "Danilo",
    club: "Juventus",
    roles: ["DIF"],
    positionTags: ["centrale", "braccetto"],
    country: "Brasile",
    score: 90,
    appearances: 37,
    starts: 35,
    statbunkerSubRaw: 2,
    goals: 3,
    tag: "Fonte 22/23",
    note: "Difensore Juventus con continuita e gol.",
  },
  {
    id: "src22-toloi-atalanta",
    name: "Rafael Toloi",
    club: "Atalanta",
    roles: ["DIF"],
    positionTags: ["centrale", "braccetto"],
    country: "Italia",
    score: 87,
    appearances: 32,
    starts: 32,
    statbunkerSubRaw: 1,
    goals: 2,
    tag: "Fonte 22/23",
    note: "Difensore Atalanta per coprire la modalita fonte.",
  },
  {
    id: "src22-biraghi-fiorentina",
    name: "Cristiano Biraghi",
    club: "Fiorentina",
    roles: ["DIF"],
    positionTags: ["terzino", "quinto"],
    country: "Italia",
    score: 87,
    appearances: 33,
    starts: 30,
    statbunkerSubRaw: 8,
    goals: 2,
    tag: "Fonte 22/23",
    note: "Terzino Fiorentina con 33 presenze.",
  },
  {
    id: "src22-lobotka-napoli",
    name: "Stanislav Lobotka",
    club: "Napoli",
    roles: ["CEN"],
    positionTags: ["regista", "mediano"],
    country: "Slovacchia",
    score: 92,
    appearances: 38,
    starts: 34,
    statbunkerSubRaw: 4,
    goals: 1,
    tag: "Fonte 22/23",
    note: "Regista del Napoli con 38 presenze.",
  },
  {
    id: "src22-zielinski-napoli",
    name: "Piotr Zielinski",
    club: "Napoli",
    roles: ["CEN"],
    positionTags: ["mezzala", "mediano"],
    country: "Polonia",
    score: 90,
    appearances: 37,
    starts: 27,
    statbunkerSubRaw: 11,
    goals: 3,
    tag: "Fonte 22/23",
    note: "Centrocampista Napoli da rotazione alta.",
  },
  {
    id: "src22-anguissa-napoli",
    name: "Frank Anguissa",
    club: "Napoli",
    roles: ["CEN"],
    positionTags: ["mezzala", "mediano"],
    country: "Camerun",
    score: 91,
    appearances: 36,
    starts: 36,
    statbunkerSubRaw: 0,
    goals: 3,
    tag: "Fonte 22/23",
    note: "Fisicita e continuita nel centrocampo scudetto.",
  },
  {
    id: "src22-barella-inter",
    name: "Nicolo Barella",
    club: "Inter",
    roles: ["CEN"],
    positionTags: ["mezzala", "mediano"],
    country: "Italia",
    score: 90,
    appearances: 35,
    starts: 31,
    statbunkerSubRaw: 6,
    goals: 6,
    tag: "Fonte 22/23",
    note: "Centrocampista Inter con 35 presenze e 6 gol.",
  },
  {
    id: "src22-rabiot-juventus",
    name: "Adrien Rabiot",
    club: "Juventus",
    roles: ["CEN"],
    positionTags: ["mezzala", "mediano"],
    country: "Francia",
    score: 90,
    appearances: 32,
    starts: 31,
    statbunkerSubRaw: 1,
    goals: 8,
    tag: "Fonte 22/23",
    note: "Centrocampista Juventus con volume e gol.",
  },
  {
    id: "src22-milinkovic-lazio",
    name: "Sergej Milinkovic-Savic",
    club: "Lazio",
    roles: ["CEN"],
    positionTags: ["mezzala", "mediano"],
    country: "Serbia",
    score: 91,
    appearances: 36,
    starts: 34,
    statbunkerSubRaw: 3,
    goals: 9,
    tag: "Fonte 22/23",
    note: "Mezzala Lazio con 9 gol nella tabella.",
  },
  {
    id: "src22-koopmeiners-atalanta",
    name: "Teun Koopmeiners",
    club: "Atalanta",
    roles: ["CEN"],
    positionTags: ["mezzala", "mediano"],
    country: "Paesi Bassi",
    score: 90,
    appearances: 33,
    starts: 32,
    statbunkerSubRaw: 1,
    goals: 10,
    tag: "Fonte 22/23",
    note: "Centrocampista Atalanta con doppia cifra.",
  },
  {
    id: "src22-lovric-udinese",
    name: "Sandi Lovric",
    club: "Udinese",
    roles: ["CEN"],
    positionTags: ["mezzala", "mediano"],
    country: "Slovenia",
    score: 86,
    appearances: 37,
    starts: 28,
    statbunkerSubRaw: 9,
    goals: 5,
    tag: "Fonte 22/23",
    note: "Centrocampista Udinese con 37 presenze.",
  },
  {
    id: "src22-lautaro-inter",
    name: "Lautaro Martinez",
    club: "Inter",
    roles: ["ATT"],
    positionTags: ["centravanti", "seconda-punta"],
    country: "Argentina",
    score: 94,
    appearances: 38,
    starts: 27,
    statbunkerSubRaw: 11,
    goals: 21,
    tag: "Fonte 22/23",
    note: "Attaccante Inter da 21 gol e 38 presenze.",
  },
  {
    id: "src22-osimhen-napoli",
    name: "Victor Osimhen",
    club: "Napoli",
    roles: ["ATT"],
    positionTags: ["centravanti", "seconda-punta"],
    country: "Nigeria",
    score: 96,
    appearances: 32,
    starts: 30,
    statbunkerSubRaw: 2,
    goals: 26,
    tag: "Fonte 22/23",
    note: "Capocannoniere del Napoli scudetto nella tabella fonte.",
  },
  {
    id: "src22-kvara-napoli",
    name: "Khvicha Kvaratskhelia",
    club: "Napoli",
    roles: ["ATT", "CEN"],
    positionTags: ["ala", "esterno", "seconda-punta"],
    country: "Georgia",
    score: 94,
    appearances: 34,
    starts: 30,
    statbunkerSubRaw: 4,
    goals: 12,
    tag: "Fonte 22/23",
    note: "Esterno Napoli con 12 gol e 34 presenze.",
  },
  {
    id: "src22-leao-milan",
    name: "Rafael Leao",
    club: "Milan",
    roles: ["ATT"],
    positionTags: ["ala", "seconda-punta"],
    country: "Portogallo",
    score: 93,
    appearances: 35,
    starts: 28,
    statbunkerSubRaw: 7,
    goals: 15,
    tag: "Fonte 22/23",
    note: "Attaccante Milan con 15 gol.",
  },
  {
    id: "src22-lookman-atalanta",
    name: "Ademola Lookman",
    club: "Atalanta",
    roles: ["ATT"],
    positionTags: ["ala", "seconda-punta", "centravanti"],
    country: "Nigeria",
    score: 91,
    appearances: 31,
    starts: 20,
    statbunkerSubRaw: 12,
    goals: 13,
    tag: "Fonte 22/23",
    note: "Attaccante Atalanta con 13 gol.",
  },
  {
    id: "src22-giroud-milan",
    name: "Olivier Giroud",
    club: "Milan",
    roles: ["ATT"],
    positionTags: ["centravanti", "seconda-punta"],
    country: "Francia",
    score: 90,
    appearances: 33,
    starts: 25,
    statbunkerSubRaw: 10,
    goals: 13,
    tag: "Fonte 22/23",
    note: "Punta Milan con 13 gol in 33 presenze.",
  },
  {
    id: "src22-immobile-lazio",
    name: "Ciro Immobile",
    club: "Lazio",
    roles: ["ATT"],
    positionTags: ["centravanti", "seconda-punta"],
    country: "Italia",
    score: 90,
    appearances: 31,
    starts: 27,
    statbunkerSubRaw: 6,
    goals: 12,
    tag: "Fonte 22/23",
    note: "Punta Lazio con 12 gol nella stagione fonte.",
  },
  {
    id: "src22-skorupski-bologna",
    name: "Lukasz Skorupski",
    club: "Bologna",
    roles: ["POR"],
    positionTags: ["portiere"],
    country: "Polonia",
    score: 86,
    appearances: 37,
    starts: 37,
    statbunkerSubRaw: 0,
    goals: 0,
    tag: "Fonte 22/23",
    note: "Portiere Bologna con 37 presenze e volume da titolare fisso.",
  },
  {
    id: "src22-lucumi-bologna",
    name: "Jhon Lucumi",
    club: "Bologna",
    roles: ["DIF"],
    positionTags: ["centrale", "braccetto"],
    country: "Colombia",
    score: 86,
    appearances: 33,
    starts: 33,
    statbunkerSubRaw: 0,
    goals: 0,
    tag: "Fonte 22/23",
    note: "Centrale Bologna sempre presente nel blocco difensivo.",
  },
  {
    id: "src22-schouten-bologna",
    name: "Jerdy Schouten",
    club: "Bologna",
    roles: ["CEN"],
    positionTags: ["mezzala", "mediano"],
    country: "Paesi Bassi",
    score: 86,
    appearances: 33,
    starts: 29,
    statbunkerSubRaw: 5,
    goals: 0,
    tag: "Fonte 22/23",
    note: "Mediano di equilibrio per rendere Bologna meno dipendente dalle solite carte.",
  },
  {
    id: "src22-ferguson-bologna",
    name: "Lewis Ferguson",
    club: "Bologna",
    roles: ["CEN", "ATT"],
    positionTags: ["mezzala", "trequartista", "seconda-punta"],
    country: "Scozia",
    score: 87,
    appearances: 32,
    starts: 27,
    statbunkerSubRaw: 9,
    goals: 7,
    tag: "Fonte 22/23",
    note: "Mezzala offensiva Bologna con sette gol.",
  },
  {
    id: "src22-orsolini-bologna",
    name: "Riccardo Orsolini",
    club: "Bologna",
    roles: ["ATT"],
    positionTags: ["ala", "seconda-punta"],
    country: "Italia",
    score: 89,
    appearances: 32,
    starts: 22,
    statbunkerSubRaw: 12,
    goals: 11,
    tag: "Fonte 22/23",
    note: "Esterno Bologna da doppia cifra in Serie A.",
  },
  {
    id: "src22-milinkovic-torino",
    name: "Vanja Milinkovic-Savic",
    club: "Torino",
    roles: ["POR"],
    positionTags: ["portiere"],
    country: "Serbia",
    score: 86,
    appearances: 38,
    starts: 38,
    statbunkerSubRaw: 0,
    goals: 0,
    tag: "Fonte 22/23",
    note: "Portiere Torino sempre presente nella tabella 2022-23.",
  },
  {
    id: "src22-rodriguez-torino",
    name: "Ricardo Rodriguez",
    club: "Torino",
    roles: ["DIF"],
    positionTags: ["centrale", "braccetto"],
    country: "Svizzera",
    score: 86,
    appearances: 35,
    starts: 30,
    statbunkerSubRaw: 7,
    goals: 0,
    tag: "Fonte 22/23",
    note: "Braccetto mancino del Torino di Juric.",
  },
  {
    id: "src22-buongiorno-torino",
    name: "Alessandro Buongiorno",
    club: "Torino",
    roles: ["DIF"],
    positionTags: ["centrale", "braccetto"],
    country: "Italia",
    score: 88,
    appearances: 34,
    starts: 30,
    statbunkerSubRaw: 6,
    goals: 1,
    tag: "Fonte 22/23",
    note: "Difensore Torino da volume alto e duelli continui.",
  },
  {
    id: "src22-vlasic-torino",
    name: "Nikola Vlasic",
    club: "Torino",
    roles: ["CEN", "ATT"],
    positionTags: ["trequartista", "seconda-punta"],
    country: "Croazia",
    score: 87,
    appearances: 34,
    starts: 29,
    statbunkerSubRaw: 5,
    goals: 5,
    tag: "Fonte 22/23",
    note: "Rifinitore del Torino con cinque gol.",
  },
  {
    id: "src22-sanabria-torino",
    name: "Antonio Sanabria",
    club: "Torino",
    roles: ["ATT"],
    positionTags: ["centravanti", "seconda-punta"],
    country: "Paraguay",
    score: 89,
    appearances: 33,
    starts: 28,
    statbunkerSubRaw: 7,
    goals: 12,
    tag: "Fonte 22/23",
    note: "Centravanti Torino da dodici gol.",
  },
  {
    id: "src22-silvestri-udinese",
    name: "Marco Silvestri",
    club: "Udinese",
    roles: ["POR"],
    positionTags: ["portiere"],
    country: "Italia",
    score: 85,
    appearances: 38,
    starts: 38,
    statbunkerSubRaw: 0,
    goals: 0,
    tag: "Fonte 22/23",
    note: "Portiere Udinese sempre presente.",
  },
  {
    id: "src22-walace-udinese",
    name: "Walace",
    club: "Udinese",
    roles: ["CEN"],
    positionTags: ["mezzala", "mediano"],
    country: "Brasile",
    score: 85,
    appearances: 37,
    starts: 37,
    statbunkerSubRaw: 0,
    goals: 0,
    tag: "Fonte 22/23",
    note: "Mediano Udinese di rottura e continuita.",
  },
  {
    id: "src22-samardzic-udinese",
    name: "Lazar Samardzic",
    club: "Udinese",
    roles: ["CEN", "ATT"],
    positionTags: ["trequartista", "seconda-punta"],
    country: "Serbia",
    score: 87,
    appearances: 37,
    starts: 19,
    statbunkerSubRaw: 19,
    goals: 5,
    tag: "Fonte 22/23",
    note: "Creatore Udinese con cinque gol e tante presenze.",
  },
  {
    id: "src22-pereyra-udinese",
    name: "Roberto Pereyra",
    club: "Udinese",
    roles: ["CEN", "ATT"],
    positionTags: ["trequartista", "seconda-punta"],
    country: "Argentina",
    score: 88,
    appearances: 34,
    starts: 33,
    statbunkerSubRaw: 3,
    goals: 5,
    tag: "Fonte 22/23",
    note: "Leader tecnico Udinese tra centrocampo e trequarti.",
  },
  {
    id: "src22-udogie-udinese",
    name: "Destiny Udogie",
    club: "Udinese",
    roles: ["DIF", "CEN"],
    positionTags: ["terzino", "quinto", "esterno"],
    country: "Italia",
    score: 88,
    appearances: 33,
    starts: 31,
    statbunkerSubRaw: 2,
    goals: 3,
    tag: "Fonte 22/23",
    note: "Quinto sinistro Udinese con gamba e tre gol.",
  },
  {
    id: "src22-beto-udinese",
    name: "Beto",
    club: "Udinese",
    roles: ["ATT"],
    positionTags: ["centravanti", "seconda-punta"],
    country: "Portogallo",
    score: 89,
    appearances: 33,
    starts: 23,
    statbunkerSubRaw: 10,
    goals: 10,
    tag: "Fonte 22/23",
    note: "Punta Udinese in doppia cifra.",
  },
  {
    id: "src22-patricio-roma",
    name: "Rui Patricio",
    club: "Roma",
    roles: ["POR"],
    positionTags: ["portiere"],
    country: "Portogallo",
    score: 88,
    appearances: 35,
    starts: 35,
    statbunkerSubRaw: 0,
    goals: 0,
    tag: "Fonte 22/23",
    note: "Portiere Roma con 35 presenze.",
  },
  {
    id: "src22-cristante-roma",
    name: "Bryan Cristante",
    club: "Roma",
    roles: ["CEN", "DIF"],
    positionTags: ["mediano", "centrale", "braccetto"],
    country: "Italia",
    score: 87,
    appearances: 36,
    starts: 34,
    statbunkerSubRaw: 2,
    goals: 1,
    tag: "Fonte 22/23",
    note: "Equilibratore Roma tra mediana e difesa.",
  },
  {
    id: "src22-mancini-roma",
    name: "Gianluca Mancini",
    club: "Roma",
    roles: ["DIF"],
    positionTags: ["centrale", "braccetto"],
    country: "Italia",
    score: 87,
    appearances: 35,
    starts: 33,
    statbunkerSubRaw: 4,
    goals: 1,
    tag: "Fonte 22/23",
    note: "Centrale Roma con continuita e aggressivita.",
  },
  {
    id: "src22-matic-roma",
    name: "Nemanja Matic",
    club: "Roma",
    roles: ["CEN"],
    positionTags: ["regista", "mediano"],
    country: "Serbia",
    score: 88,
    appearances: 35,
    starts: 16,
    statbunkerSubRaw: 20,
    goals: 2,
    tag: "Fonte 22/23",
    note: "Regia fisica e gestione nei finali della Roma.",
  },
  {
    id: "src22-ibanez-roma",
    name: "Roger Ibanez",
    club: "Roma",
    roles: ["DIF"],
    positionTags: ["centrale", "braccetto"],
    country: "Brasile",
    score: 87,
    appearances: 33,
    starts: 32,
    statbunkerSubRaw: 4,
    goals: 3,
    tag: "Fonte 22/23",
    note: "Braccetto Roma con tre gol e tante partenze.",
  },
  {
    id: "src22-zalewski-roma",
    name: "Nicola Zalewski",
    club: "Roma",
    roles: ["DIF", "CEN"],
    positionTags: ["terzino", "quinto", "esterno"],
    country: "Polonia",
    score: 86,
    appearances: 33,
    starts: 26,
    statbunkerSubRaw: 10,
    goals: 2,
    tag: "Fonte 22/23",
    note: "Esterno Roma adattabile su tutta la fascia.",
  },
  {
    id: "src22-pellegrini-roma",
    name: "Lorenzo Pellegrini",
    club: "Roma",
    roles: ["CEN", "ATT"],
    positionTags: ["trequartista", "seconda-punta"],
    country: "Italia",
    score: 90,
    appearances: 32,
    starts: 29,
    statbunkerSubRaw: 6,
    goals: 4,
    tag: "Fonte 22/23",
    note: "Capitano Roma tra calcio piazzato e rifinitura.",
  },
  {
    id: "src22-smalling-roma",
    name: "Chris Smalling",
    club: "Roma",
    roles: ["DIF"],
    positionTags: ["centrale", "braccetto"],
    country: "Inghilterra",
    score: 89,
    appearances: 32,
    starts: 31,
    statbunkerSubRaw: 3,
    goals: 3,
    tag: "Fonte 22/23",
    note: "Centrale Roma dominante nel gioco aereo.",
  },
  {
    id: "src22-augello-sampdoria",
    name: "Tommaso Augello",
    club: "Sampdoria",
    roles: ["DIF", "CEN"],
    positionTags: ["terzino", "quinto", "esterno"],
    country: "Italia",
    score: 84,
    appearances: 37,
    starts: 35,
    statbunkerSubRaw: 3,
    goals: 2,
    tag: "Fonte 22/23",
    note: "Fascia sinistra Sampdoria da alto volume.",
  },
  {
    id: "src22-gabbiadini-sampdoria",
    name: "Manolo Gabbiadini",
    club: "Sampdoria",
    roles: ["ATT"],
    positionTags: ["centravanti", "seconda-punta"],
    country: "Italia",
    score: 86,
    appearances: 35,
    starts: 27,
    statbunkerSubRaw: 10,
    goals: 7,
    tag: "Fonte 22/23",
    note: "Piede mancino Sampdoria da sette gol.",
  },
  {
    id: "src22-rincon-sampdoria",
    name: "Tomas Rincon",
    club: "Sampdoria",
    roles: ["CEN"],
    positionTags: ["mezzala", "mediano"],
    country: "Venezuela",
    score: 84,
    appearances: 34,
    starts: 30,
    statbunkerSubRaw: 6,
    goals: 0,
    tag: "Fonte 22/23",
    note: "Mediano Sampdoria per pack di sacrificio e lavoro sporco.",
  },
  {
    id: "src22-djuricic-sampdoria",
    name: "Filip Djuricic",
    club: "Sampdoria",
    roles: ["CEN", "ATT"],
    positionTags: ["trequartista", "seconda-punta"],
    country: "Serbia",
    score: 85,
    appearances: 32,
    starts: 27,
    statbunkerSubRaw: 6,
    goals: 3,
    tag: "Fonte 22/23",
    note: "Creatore Sampdoria per variare i pacchetti moderni.",
  },
  {
    id: "src22-dodo-fiorentina",
    name: "Dodo",
    club: "Fiorentina",
    roles: ["DIF", "CEN"],
    positionTags: ["terzino", "quinto", "esterno"],
    country: "Brasile",
    score: 86,
    appearances: 33,
    starts: 28,
    statbunkerSubRaw: 7,
    goals: 1,
    tag: "Fonte 22/23",
    note: "Terzino Fiorentina di spinta e rotazione europea.",
  },
  {
    id: "src22-ikone-fiorentina",
    name: "Jonathan Ikone",
    club: "Fiorentina",
    roles: ["ATT", "CEN"],
    positionTags: ["ala", "esterno", "seconda-punta"],
    country: "Francia",
    score: 86,
    appearances: 33,
    starts: 24,
    statbunkerSubRaw: 14,
    goals: 4,
    tag: "Fonte 22/23",
    note: "Esterno Fiorentina per pack creativi ma non automatici.",
  },
  {
    id: "src22-jovic-fiorentina",
    name: "Luka Jovic",
    club: "Fiorentina",
    roles: ["ATT"],
    positionTags: ["centravanti", "seconda-punta"],
    country: "Serbia",
    score: 87,
    appearances: 31,
    starts: 16,
    statbunkerSubRaw: 19,
    goals: 6,
    tag: "Fonte 22/23",
    note: "Punta Fiorentina da rotazione e sei gol.",
  },
];

export const sourcedSerieA2022Players: PlayerSeason[] = rows.map((row) => ({
  ...row,
  season: "2022-23",
  era: "moderna",
  source: {
    name: "StatBunker",
    url: sourceUrl,
    retrievedAt: "2026-06-06",
    table: "Serie A 22/23 Most appearances",
    statFields: ["Total", "Start", "Sub", "Goals"],
    roleMapping: "manual gameplay mapping",
  },
}));
